import { render, staticRenderFns } from "./ApplyForMastercard.vue?vue&type=template&id=3c271e8b"
import script from "./ApplyForMastercard.vue?vue&type=script&lang=js"
export * from "./ApplyForMastercard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports